<template>
<div class="cart-table__quantity input-number">
    <input 
        class="form-control-order-entry-qty-selector input-number__input" 
        type="number" 
        min="1" 
        :value="modelValue"
        @change="$emit('update:modelValue', $event.target.value);$emit('changedQty', $event.target.value)"
    />
    <!-- // removed mousedown, leave and up because it's not working with the Swiper -->
    <!-- @mousedown.left="startChange('add')" @mouseup="stopChange" @mouseleave="stopChange" -->
    <div class="input-number__add" @click="startChange('add')" ></div>
    <div class="input-number__sub" @click="startChange('sub')" ></div>
    <!-- @mousedown.left="startChange('sub')" @mouseup="stopChange" @mouseleave="stopChange" -->
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: [String, Number],
            default: 0
        }
    },
    data() {
        return {
            interval: false,
            timeout: 0
        }
    },
    methods: {
        startChange(form) {
            // removed interval because it's not working with the Swiper
            // if (!this.interval) {
            //     this.interval = setInterval(() => {
            let qty = 0
            if (!isNaN(parseInt(this.modelValue))) {
                qty = parseInt(this.modelValue)
            }
            if (form === 'add') {
                qty += 1;
            } else {
                qty = (qty - 1 < 0) ? qty = 0 : qty - 1;
            }
            this.$emit('update:modelValue', qty);
            this.$emit('changedQty', qty);
                // }
            //     , 100)
            // }
        },
        stopChange() {
            clearInterval(this.interval);
            this.interval = false;
        },
    }
}
</script>